import { render, staticRenderFns } from "./Muestras.vue?vue&type=template&id=d8f0da46&scoped=true"
import script from "./Muestras.vue?vue&type=script&lang=js"
export * from "./Muestras.vue?vue&type=script&lang=js"
import style0 from "./Muestras.vue?vue&type=style&index=0&id=d8f0da46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f0da46",
  null
  
)

export default component.exports